import React, { useState } from 'react';
import Modal from 'Components/Modal';
import Alert from 'Components/Alert';
import Title from 'Components/Title';
import FilterContainer from 'Containers/FilterContainer';
import Search from 'Components/Search';
import Dropdown from 'Components/DropDown';
import BasicTable from 'Components/BasicTable';
import Grid from '@mui/material/Grid';
import useTranslation from 'Hooks/useTranslation';
import { useLocation } from 'react-router-dom';
import useModal from './Hooks/useModal';
import useConfirmationModal from './Hooks/useConfirmationModal';
import useFetch from './Hooks/useFetch';
import useComponent from './Hooks/useComponent';
import useDeleteUser from './Hooks/useDeleteUser';
import EnrollUsersModal from './Components/EnrollUsersModal';
import { MembersContainer, dropdownStyle, ContainerTable, FloatingButton } from './style';

export default function EditCourseMembers() {
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { openModal, setOpenModal } = useModal();
  const { setOpenConfirmationModal, ConfirmationModal } = useConfirmationModal();
  const { t2 } = useTranslation('EditCourse');
  const location = useLocation();
  const courseId = location?.state?.course[(location?.state?.course?.length || 0) - 1];

  const {
    users,
    courseUsers,
    departments,
    jobTitles,
    terminals,
    setDepartment,
    setJobTitle,
    setTerminal,
    setFullName,
    enrollUsers,
    setCourseUsers,
    setUsers,
  } = useFetch(courseId, setIsLoading);

  const { confirmationDeleteUser, deleteUser } = useDeleteUser(
    courseUsers,
    setCourseUsers,
    courseId,
    setOpenConfirmationModal,
    setOpen,
    setOpenError
  );

  const { thereIsComponent } = useComponent({ courseUsers });

  const handleAccept = async data => {
    const userIds = data.map(user => user.id);
    const res = await enrollUsers(courseId, userIds);

    if (res.value === 1) {
      const mappedUsers = data.map(user => [
        user?.fullName,
        user?.Department?.name,
        user?.JobTitle?.name,
        user?.Terminal?.name,
        user?.progress || null,
        user?.id,
        true,
      ]);
      const sortedUsers = [...courseUsers, ...mappedUsers].sort();
      setCourseUsers(sortedUsers);
      setUsers(users.filter(user => !userIds.includes(user.id)));
      setOpenModal(false);
      setOpen(true);
    } else {
      setOpen(true);
      setOpenError(true);
    }
    setOpenModal(false);
  };

  const employeeOptions = [t2('DeleteFromCourse')];

  return (
    <>
      <FloatingButton onClick={() => setOpenModal(true)}>{t2('EnrollUsers')}</FloatingButton>
      <Title title="Miembros" />
      <MembersContainer>
        <FilterContainer>
          <Grid item xs={4} style={{ paddingLeft: '0' }}>
            <Search placeholder={t2('SearchPlaceholder')} setData={setFullName} />
          </Grid>

          <Grid item xs={6} style={dropdownStyle}>
            <Dropdown title={t2('Terminal')} setData={setTerminal} options={terminals} />
            <Dropdown title={t2('JobTitle')} setData={setJobTitle} options={jobTitles} />
            <Dropdown title={t2('Department')} setData={setDepartment} options={departments} />
          </Grid>
        </FilterContainer>
        <ContainerTable>
          <BasicTable
            information={courseUsers}
            headers={[t2('EmployeeName'), t2('Department'), t2('JobTitle'), t2('Terminal'), t2('CourseProgress')]}
            limit={5}
            configButton={employeeOptions}
            configButtonEvents={[confirmationDeleteUser]}
            thereIsComponent={thereIsComponent}
            widthColumn="20%"
            isLoading={isLoading}
          />
        </ContainerTable>
      </MembersContainer>
      <Modal
        open={openModal}
        setOpen={setOpenModal}
        Children={
          <EnrollUsersModal
            users={users}
            title={t2('AddMembers')}
            cancel={() => setOpenModal(false)}
            accept={handleAccept}
          />
        }
      />
      <ConfirmationModal onAccept={deleteUser} />
      <Alert
        message={!openError ? t2('AlertSuccessEditCourseMembers') : t2('AlertNotSuccessfullEditCourseMembers')}
        open={open}
        setOpen={setOpen}
        error={openError}
      />
    </>
  );
}
